
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 270 270","xml:space":"preserve","y":"0","x":"0","id":"Layer_1_1619215583014","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('path',{staticClass:"st0_1619215583014",attrs:{"d":"M189.6 160.1c-7.9 0-14.3 6.4-14.3 14.3s6.4 14.3 14.3 14.3 14.3-6.4 14.3-14.3c0-8-6.4-14.3-14.3-14.3zm-42.8 14.2c0-23.7 19.2-42.8 42.8-42.8s42.8 19.2 42.8 42.8-19.2 42.8-42.8 42.8-42.8-19.1-42.8-42.8z","vector-effect":"non-scaling-stroke"}}),_c('path',{staticClass:"st0_1619215583014",attrs:{"vector-effect":"non-scaling-stroke","d":"M175.3 194.9h28.6v67.5h-28.6zM175.3 3h28.6v131h-28.6zM76.6 105.4c7.9 0 14.3-6.4 14.3-14.3s-6.4-14.3-14.3-14.3-14.3 6.4-14.3 14.3 6.5 14.3 14.3 14.3zm42.9-14.3c0 23.7-19.2 42.8-42.8 42.8s-42.8-19.2-42.8-42.8S53 48.3 76.6 48.3s42.9 19.2 42.9 42.8z"}}),_c('path',{staticClass:"st0_1619215583014",attrs:{"transform":"rotate(-180 76.636 36.752)","vector-effect":"non-scaling-stroke","d":"M62.4 3H91v67.5H62.4z"}}),_c('path',{staticClass:"st0_1619215583014",attrs:{"transform":"rotate(-180 76.636 196.95)","vector-effect":"non-scaling-stroke","d":"M62.4 131.5H91v131H62.4z"}})])])
          )
        }
      }
    